<script lang="ts" setup>
const {collectionUri, pageUri} = useI18nCollection();
const hero = await queryCollection(collectionUri('home')).path(pageUri('home/hero')).first();
const heroImageRefIndex = ref<number>(0);
const heroImage = computed(() => (hero?.meta?.imageRef?.[heroImageRefIndex.value] || '').replace('/assets', ''));
const config = useRuntimeConfig().public;
const { t } = useI18n();

// SEO optimization
const index = await queryCollection(collectionUri('home')).first();
useSeo({
  title: index?.seoTitle || t('seo.home.title'),
  description: index?.seoDescription || t('seo.home.description'),
});

// Schema.org structured data
const { organizationSchema, localBusinessSchema, websiteSchema, addSchemas } = useSchemaOrg();
addSchemas([organizationSchema, localBusinessSchema, websiteSchema]);
</script>

<template>
  <main>
    <header class="page-container relative mb-8">
      <h1 class="hero-title mb-4 laptop:absolute left-[100px] top-[100px] z-2">
        <span class="text-brand inline tablet:block laptop:text-shadow-2xs me-2">{{ hero.title }}</span>
        <small class="text-grey laptop:text-light laptop:text-shadow-2xs">{{ hero.meta.subtitle }}</small>
      </h1>
      <HeroImg :faded="true" :uri="heroImage" :alt="hero?.title || t('seo.images.hero')" class="z-1 relative"/>
    </header>

    <SectionServices/>
    <SectionAboutAermec/>
    <SectionHomeBannerCta/>
    <SectionProjects/>

    <div aria-hidden="true" hidden>
      <template v-for="uri in hero?.meta?.imageRef" :key="uri">
        <media-source
                :dimensions="[
                { width: 3800, height: 2560 },
                { width: 2500, height: 1170 },
                { width: 1900, height: 1080 },
            ]"
                :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
                :uri="uri.replace('/assets', '')"
                as="source"
                format="jpg"
                sizes="100vw"
        />

        <media-source
                :dimensions="[
                { width: 3800, height: 2560 },
                { width: 2500, height: 1170 },
                { width: 1900, height: 1080 },
            ]"
                :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
                :uri="uri.replace('/assets', '')"
                as="source"
                format="webp"
                sizes="100vw"
        />

        <media-source
                :dimensions="[
                { width: 1920, height: Math.round(1920/2.1641025641) },
                { width: 1200, height: Math.round(1200/2.1641025641) },
                { width: 780, height: Math.round(780/2.1641025641) },
            ]"
                :media="`(max-width: ${config.ui.breakpoints.tablet.width - 1}px)`"
                :uri="uri.replace('/assets', '')"
                as="source"
                format="webp"
                sizes="100vw"
        />

        <media-source
                :alt="config.siteName"
                :dimensions="[
                { width: 1920, height: Math.round(1920/2.1641025641) },
                { width: 1200, height: Math.round(1200/2.1641025641) },
                { width: 780, height: Math.round(780/2.1641025641) },
            ]"
                :uri="uri.replace('/assets', '')"
                as="img"
                class="object-cover"
                format="jpg"
                loading="eager"
                sizes="100vw"
        />
      </template>
    </div>
  </main>
</template>